/**
 * Build-time configuration. The app refuses to run without an explicit Supabase
 * URL and key — there is no fake backend fallback.
 */
const url = ((import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? '').trim();
const anonKey = ((import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '').trim();
const siteUrl = ((import.meta.env.VITE_SITE_URL as string | undefined) ?? '').trim();
const sentryDsn = ((import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '').trim();

export const env = {
  supabaseUrl: url.replace(/\/$/, ''),
  supabaseAnonKey: anonKey,
  configured: /^https?:\/\//.test(url) && anonKey.length > 20,
  siteUrl: siteUrl.replace(/\/$/, ''),
  isDev: import.meta.env.DEV,
  /** Error reporting is off unless a DSN is configured (never in local dev by default). */
  sentryDsn,
  sentryEnvironment: ((import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? '').trim() || (import.meta.env.DEV ? 'development' : 'production'),
  /** Commit SHA on Cloudflare Pages builds; 'local' otherwise. */
  release: __APP_RELEASE__,
};

/** Absolute URL for auth email redirects: the page origin in browsers, VITE_SITE_URL otherwise. */
export function authRedirect(path: string): string {
  const origin = typeof window !== 'undefined' && /^https?:/.test(window.location.origin) ? window.location.origin : env.siteUrl;
  return `${origin}${path}`;
}
